import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { object, string } from 'yup';

import ConfirmationAlert from './ConfirmationAlert';
import ErrorAlert from './ErrorAlert';
import { addNameToHtml } from '../Templates/customerEmailHelpConfirmation';

const sendEmail = async (formdata, region) => {
  const { REACT_APP_ENVIRONMENT, REACT_APP_SEND_EMAIL_URL } = process.env;

  // send email to RapidAIM about potential lead
  let subject = `[HELP] from ${region.toUpperCase()} pest forecast`;

  // ths is where we want our enquiries to go to e.g. enquiries@rapidaim.io
  let rapidaimEmail =
    REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'production'
      ? 'enquiries@rapidaim.io'
      : formdata.email;

  let body_text = 'Name: ' + formdata.firstname + '\n';
  body_text = body_text + 'Surname: ' + formdata.lastname + '\n';
  body_text = body_text + 'Email: ' + formdata.email + '\n';
  body_text = body_text + 'Phone no.: ' + formdata.phonenumber + '\n';

  let body_html = '<div><ul>';
  body_html = body_html + '<li>Name: ' + formdata.firstname + '</li>';
  body_html = body_html + '<li>Surname: ' + formdata.lastname + '</li>';
  body_html = body_html + '<li>Email: ' + formdata.email + '</li>';
  body_html = body_html + '<li>Phone no: ' + formdata.phonenumber + '</li>';
  body_html = body_html + '<li>Message: ' + formdata.message + '</li>';
  body_html = body_html + '</ul></div>';

  let url = REACT_APP_SEND_EMAIL_URL;
  let request = {
    method: 'post',
    url: url,
    data: {
      subject: subject,
      dest: rapidaimEmail,
      body_text: body_text,
      body_html: body_html,
      src: rapidaimEmail,
    },
  };

  try {
    let response = await axios(request);
    console.log('Lead email server response:', response);

    // send confirmation email to interested parties that we have received the request to contact
    const customerHtml = addNameToHtml({ firstname: formdata.firstname });

    rapidaimEmail = 'enquiries@rapidaim.io';
    subject = 'Thank you for reaching out to RapidAIM';

    let request2 = {
      method: 'post',
      url: url,
      headers: {},
      data: {
        subject: subject,
        dest: formdata.email,
        body_text: customerHtml,
        body_html: customerHtml,
        src: rapidaimEmail,
      },
    };

    if (response.status === 201) {
      let response2 = await axios(request2);
      console.log('Confirmation email server response: ', response2);
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log('Sending of lead email failed with error:', err);
    return false;
  }
};

function HelpModal({ region, show, handleClose }) {
  const { t } = useTranslation('translation', { keyPrefix: 'helpModal' });
  const [showOK, setShowOK] = useState(false);
  const [showERR, setShowERR] = useState(false);
  const [disableBTN, setDisableBTN] = useState(false);
  const [msg, setMsg] = useState('Submission failed. Please try again.');

  const formik = useFormik({
    initialValues: {
      firstname: '',
      lastname: '',
      email: '',
      phonenumber: '',
      message: '',
    },
    onSubmit: (values) => handleSubmit(values),
    validationSchema: object().shape({
      firstname: string().required('Please fill in your first name'),
      lastname: string(),
      email: string()
        .email('The email is not valid')
        .required('Please fill in your email'),
      phonenumber: string(),
      message: string().required('Please fill in your message'),
    }),
  });

  function handleSubmit(values) {
    setShowOK(false);
    setShowERR(false);
    setDisableBTN(true);

    sendEmail(values, region).then((success) => {
      console.log('Email Sent?', success);
      setDisableBTN(false);

      if (success) {
        setShowOK(true);
        formik.handleReset();
      } else {
        setMsg('Submission failed. Please try again.');
        setShowERR(true);
      }
    });
  }

  function handleCClose() {
    setShowOK(false);
    setShowERR(false);
    setDisableBTN(false);
    formik.handleReset();
    handleClose();
  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header style={{ backgroundColor: '#282878' }}>
        <Modal.Title>
          <h2 style={{ color: '#ffffff' }}>{t('title')}</h2>
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <Row className="mb-2">
            <h3>{t('body')}</h3>
          </Row>
          <Row>
            <Col sm={6} className="my-2">
              <Form.Control
                id="firstname"
                type="text"
                placeholder="First Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstname}
                isInvalid={formik.errors.firstname && formik.touched.firstname}
              />

              <Form.Control.Feedback type="invalid">
                {formik.errors.firstname}
              </Form.Control.Feedback>
            </Col>
            <Col sm={6} className="my-2">
              <Form.Control
                id="lastname"
                type="text"
                placeholder="Last Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastname}
                isInvalid={formik.errors.lastname && formik.touched.lastname}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.lastname}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="my-2">
              <Form.Control
                id="email"
                type="email"
                placeholder="Email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                isInvalid={formik.errors.email && formik.touched.email}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Col>
            <Col sm={6} className="my-2">
              <Form.Control
                id="phonenumber"
                type="tel"
                placeholder="Phone Number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phonenumber}
                isInvalid={
                  formik.errors.phonenumber && formik.touched.phonenumber
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.phonenumber}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="my-2">
              <Form.Control
                id="message"
                type="text"
                as="textarea"
                rows={3}
                placeholder="Message"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.message}
                isInvalid={formik.errors.message && formik.touched.message}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.message}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <ConfirmationAlert show={showOK} message={t('confirmationMessage')} />
          <ErrorAlert show={showERR} setShow={setShowERR} msg={msg} />
        </Modal.Body>
        <Modal.Footer>
          <Button id='helpModalClose'
            size="sm"
            variant="outline-dark"
            className="mr-3 ml-auto"
            onClick={handleCClose}
            disabled={disableBTN}
          >
            {t('close')}
          </Button>
          <Button id='submitHelp'
            size="sm"
            variant="success"
            className="font-weight-bold text-white"
            type="submit"
            disabled={disableBTN}
          >
            {t('submit')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default HelpModal;
